import withTranslation from 'utils/react/withTranslation';
import { connect } from 'react-redux';
import createImmutableSelector from 'utils/immutable-selector';

import {
  canManageVehiclesSelector,
  currentUserConfigSelector,
  currentProjectConfigSelector,
  isDeliveryLayoutSelector,
  isSuperuserSelector,
  isStaffSelector,
  capacityFunctorSelector,
} from 'modules/user/selectors';
import {
  editableBookingsSelector,
  commuteOfferIsReadOnlySelector,
  commuteOfferLoadedCommuteOfferSelector,
  commuteOfferLoadedSimulationSelector,
  operationStatisticsSelector,
} from 'modules/commuteOffer/selectors';
import {
  clonedVehicle,
  deleteVehicle,
  addPointToRoute,
  addStopToRoute,
  setVehicleStartTime,
  recalculateVehicleTime,
  showVehicleUpdates,
  showVehicleSource,
  recalculateRoute,
  commuteOfferRequestUpdate,
} from 'modules/commuteOffer/actions';
import { filteredStopsSelector } from 'modules/entities/selectors';

import {
  activeVehicleIdsSelector,
  activeRouteStopUidSelector,
  addPointModeSelector,
  addStopModeSelector,
  stopSearchQuerySelector,
  commuteOffersIsTemplateDataSourceSelector,
} from 'modules/ui/selectors';
import {
  setActiveVehicleId,
  cleanActiveVehicleId,
  setEditableVehicleId,
  cleanActiveRouteStop,
  setAddPointMode,
  cleanAddPointMode,
  setAddStopMode,
  setStopSearchQuery,
  cleanAddStopMode,
  toggleEditableTimeMode,
  openPopup,
} from 'modules/ui/actions';

import Vehicle from './Vehicle';

const mapStateToProps = createImmutableSelector(
  editableBookingsSelector,
  activeVehicleIdsSelector,
  activeRouteStopUidSelector,
  addPointModeSelector,
  addStopModeSelector,
  filteredStopsSelector,
  stopSearchQuerySelector,
  commuteOfferIsReadOnlySelector,
  canManageVehiclesSelector,
  commuteOfferLoadedCommuteOfferSelector,
  commuteOfferLoadedSimulationSelector,
  isDeliveryLayoutSelector,
  isStaffSelector,
  isSuperuserSelector,
  currentUserConfigSelector,
  currentProjectConfigSelector,
  capacityFunctorSelector,
  operationStatisticsSelector,
  commuteOffersIsTemplateDataSourceSelector,
  (
    editableBooking,
    activeVehicleIds,
    activeRouteStopUid,
    pointEditing,
    addStopMode,
    filteredStops,
    stopSearchQuery,
    isReadOnly,
    canManageVehicles,
    loadedCommuteOffer,
    simulation,
    isDeliveryLayout,
    isStaff,
    isSuperuser,
    currentUserConfig,
    projectConfig,
    capacityFunctor,
    operationStatistics,
    isTemplate
  ) => ({
    editableBooking,
    activeVehicleIds,
    activeRouteStopUid,
    pointEditing,
    addStopMode,
    filteredStops,
    stopSearchQuery,
    isReadOnly,
    canManageVehicles,
    loadedCommuteOffer,
    simulation,
    isDeliveryLayout,
    isStaff,
    isSuperuser,
    currentUserConfig,
    projectConfig,
    capacityFunctor,
    operationStatistics,
    isTemplate,
  })
);

const mapDispatchToProps = {
  setActiveVehicleId,
  cleanActiveVehicleId,
  setEditableVehicleId,
  clonedVehicle,
  deleteVehicle,
  addPointToRoute,
  cleanActiveRouteStop,
  setAddPointMode,
  cleanAddPointMode,
  setAddStopMode,
  cleanAddStopMode,
  setStopSearchQuery,
  addStopToRoute,
  setVehicleStartTime,
  recalculateVehicleTime,
  toggleEditableTimeMode,
  openPopup,
  showVehicleUpdates,
  showVehicleSource,
  commuteOfferRequestUpdate,
  recalculateRoute,
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(withTranslation()(Vehicle));
